import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};
export default function DeviceContentWrapper({ children }: Props) {
  return (
    <div id="tablet" className="relative flex size-full bg-dark-900 overflow-clip">
      {children}
    </div>
  );
}
